export const CONTRIBUTION_TYPE = {
  ONE_OFF: 'oneOff',
  MONTHLY_PERCENTAGE: 'monthlyPercentage',
  MONTHLY_PERCENTAGE_WITH_CONTRIBUTION_PERIOD:
    'monthlyPercentageWithContributionPeriod',
  MONTHLY_AMOUNT: 'monthlyAmount',
}
